if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      this.classList.add('init');

      if (FoxTheme.config.mqlTablet && !this.openDefault) {
        this.isOpen = false;
        this.removeAttribute('open');
        this.parentElement?.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
      }else{
        this.setAttribute('open', true);
      }

      document.addEventListener('matchTablet', () => {
        this.open = this.openDefault;
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
      
    }

    
  }
   customElements.define('footer-details', FooterDetails, { extends: 'details' });
}